var InvitationStates;
(function (InvitationStates) {
    InvitationStates["PENDING"] = "Pending";
    InvitationStates["CANCELED"] = "Canceled";
    InvitationStates["ACCEPTED"] = "Accepted";
    InvitationStates["DECLINED"] = "Declined";
    InvitationStates["EXPIRED"] = "Expired";
})(InvitationStates || (InvitationStates = {}));
export default InvitationStates;
